import React, { createContext, useContext, useState } from 'react';

const StateContext = createContext();

export const StateProvider = ({ children }) => {
    const [selectedState, setSelectedState] = useState('');

    // Explicitly check for valid state - excludes '', null, undefined, {}, and 'Unspecified'
    const isStateSelected = typeof selectedState === 'string' &&
        selectedState.length > 0 &&
        selectedState !== 'Unspecified';

    return (
        <StateContext.Provider value={{
            selectedState,
            setSelectedState,
            isStateSelected
        }}>
            {children}
        </StateContext.Provider>
    );
};

export const useStateContext = () => {
    const context = useContext(StateContext);
    if (!context) {
        throw new Error('useStateContext must be used within a StateProvider');
    }
    return context;
};

export default StateContext;
